
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const announcement = createApi({
    reducerPath: 'announcement',
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['announcement','iqamahannouncement'],
    endpoints: (builder) => ({
        getannouncement: builder.query({
            query: ({ page = 1, limit = 10, search }) => `/api/announcement/get-announcements?page=${page}&limit=${limit}&search=${search}`,
            providesTags: (result, error, { page, limit }) => [
                { type: 'announcement', id: `page-${page}-limit-${limit}` },
            ],
        }),

        createannouncement: builder.mutation({
            query: (data) => ({
                url: `/api/announcement/create-new-announcement`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['announcement'],
        }),

        deleteannouncement: builder.mutation({
            query: (id) => ({
                url: `/api/announcement/delete-announcement/${id}`,  // Send the `id` as a query parameter
                method: 'DELETE',  // Or DELETE if your backend expects DELETE
            }),
            invalidatesTags: ['announcement'],
        }),


        updateannouncement: builder.mutation({
            query: (data) => ({
                url: `/api/announcement/update-announcement`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['announcement'],
        }),

        iqamahannouncement: builder.mutation({
            query: (data) => ({
                url: `/api/iqamah-announcement/cu-iqamah-change-announcement`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['iqamahannouncement'],
        }),

        getiqmahannouncement: builder.query({
            query: () => `/api/iqamah-announcement/get-iqamah-change-announcement`,
            providesTags: ['iqamahannouncement'],
        }),

        
    }),
});

export const {
    useGetannouncementQuery,
    useCreateannouncementMutation,
    useDeleteannouncementMutation,
    useUpdateannouncementMutation,
    useIqamahannouncementMutation,
    useGetiqmahannouncementQuery
} = announcement;